import { BoxProps, TextProps } from '@jfs/ui-new'

const commonRoundedCircle = {
  width: 16,
  height: 16,
  borderRadius: 16 / 2,
  justifyContent: 'center',
}

const labelCommonTextStyle = {
  fontSize: 12,
  textAlign: 'center',
}

const styles = {
  container: {
    width: '100%',
    flexDirection: 'row',
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingVertical: 16,
    paddingHorizontal: 24,
  } as BoxProps,

  roundedCircle: {
    ...commonRoundedCircle,
    alignSelf: 'center',
    backgroundColor: 'VERY_LIGHT_GREY',
  } as BoxProps,

  roundedCircleFilled: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  } as BoxProps,

  contentWrapper: {
    overflow: 'hidden',
  } as BoxProps,

  labelText: {
    ...labelCommonTextStyle,
    fontWeight: '800',
    color: 'GREEN',
  } as TextProps,

  currentLabel: {
    ...labelCommonTextStyle,
    fontWeight: '800',
    color: 'PRIMARY',
  } as TextProps,

  labelTextLight: {
    ...labelCommonTextStyle,
    fontWeight: '800',
    color: 'BLACK_STRIKE',
  } as TextProps,

  textWrapper: {
    justifyContent: 'flex-start',
    paddingTop: 10,
  } as BoxProps,

  separator: {
    backgroundColor: 'VERY_LIGHT_GREY',
    flex: 1,
    height: 1,
    marginBottom: 24,
  } as BoxProps,

  stepText: {
    fontWeight: '600',
    color: 'WHITE',
    fontSize: 12,
    textAlign: 'center',
  } as TextProps,
}

export default styles
